"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useId = void 0;
var tslib_1 = require("tslib");
var nanoid_1 = require("nanoid");
var react_1 = tslib_1.__importDefault(require("react"));
function useId(id) {
    var _a, _b, _c;
    try {
        // eslint-disable-next-line import/no-named-as-default-member
        var generatedId = (_c = (_b = (_a = react_1.default).useId) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : (0, nanoid_1.nanoid)();
        return id !== null && id !== void 0 ? id : generatedId;
    }
    catch (error) {
        return id !== null && id !== void 0 ? id : (0, nanoid_1.nanoid)();
    }
}
exports.useId = useId;
//# sourceMappingURL=use-id.js.map